import React, {useContext} from "react";
import {DealPageContext} from "../index";
import {CriticalErrorsComponent} from "../../../domains/common/components/CriticalErrors";

export const DealContent = () => {
  const {dealContainer, dataHasLoaded} = useContext(DealPageContext);

  return (
    <>
      {dataHasLoaded ? <CriticalErrorsComponent/> : void 0}
      {dealContainer}
    </>
  )};